import Card from "./Card";
import TablePaginate from "../table/TablePaginate";
import { CardTablePropsInterface } from './typings';

export default function CardTable({ extras, title, columns, loading, datas, pagination, setPagination, tableClassName = "" }: CardTablePropsInterface) {
    return <>
        <Card title={title} extras={extras}>
            <TablePaginate columns={columns} loading={loading} datas={datas} pagination={pagination} setPagination={setPagination} tableClassName={tableClassName} />
        </Card>
    </>
}
